import { OrmModel, StringField, AttrField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import { getFullName } from '@/utils/fullName'

@OrmModel(modelNames.USER_PERSONAL_INFO)
export default class UserPersonalInfo extends BaseModel {
  @StringField('')
  public id: string

  @AttrField()
  public avatarUrl: string | null

  @AttrField()
  public firstName: string | null

  @AttrField()
  public lastName: string | null

  @StringField()
  public email: string

  public get fullName() {
    return getFullName(this.firstName, this.lastName)
  }
}
